import {
    OutlinedInput,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';

import CancelIcon from 'ui/CancelIcon';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import PendingDelete from '../PendingDelete';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const recipientsListStyles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        maxHeight: 320,
        overflow: 'auto',
        overflowX: 'none',
    },

    cell: {
        padding: 8,
    },
});

class RecipientsList extends React.Component {
    render() {
        const {
            classes,
            recipients,
            permissionsOptions,
            onChange,
            onRemove,
            editable = true,
            maxHeight,
        } = this.props;

        return (
            <div className={classes.container} style={{ maxHeight: maxHeight }}>
                <Table style={{ height: '100%' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell
                                style={{
                                    width: '460px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Recipients
                            </TableCell>
                            <TableCell
                                style={{
                                    minWidth: '200px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Permissions
                            </TableCell>
                            <TableCell
                                style={{
                                    width: '50px',
                                }}
                            />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {recipients.map((recipient, recipientIndex) => (
                            <TableRow key={recipientIndex}>
                                <TableCell align="left">
                                    {recipient.is_pending_delete ? (
                                        <PendingDelete name={recipient.name} />
                                    ) : (
                                        <>{recipient.name}</>
                                    )}
                                </TableCell>
                                <TableCell
                                    align="left"
                                    style={{ paddingRight: 10 }}
                                >
                                    <Select
                                        style={{
                                            minWidth: '180px',
                                            fontSize: '0.8125rem',
                                        }}
                                        value={recipient.permissions}
                                        input={
                                            <OutlinedInput
                                                labelWidth={0}
                                                name="permissions"
                                                id="outlined-age-native-simple"
                                            />
                                        }
                                        onChange={(prop, val) =>
                                            onChange(
                                                recipient.name,
                                                val.props.value
                                            )
                                        }
                                        disabled={
                                            !editable ||
                                            recipient.is_pending_delete
                                        }
                                    >
                                        {permissionsOptions.map(
                                            (permission, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={permission.key}
                                                >
                                                    {permission.name}
                                                </MenuItem>
                                            )
                                        )}
                                    </Select>
                                </TableCell>
                                <TableCell>
                                    <IconButton
                                        style={{
                                            padding: 0,
                                            width: 0,
                                        }}
                                        onClick={() => onRemove(recipient.name)}
                                    >
                                        <CancelIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        );
    }
}

export default withStyles(recipientsListStyles)(RecipientsList);
